var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0001 13.1665C5.8721 13.1665 5.74408 13.1179 5.64674 13.0199C5.45141 12.8245 5.45141 12.5078 5.64674 12.3125L9.96006 7.9992L5.64674 3.68589C5.45141 3.49055 5.45141 3.17386 5.64674 2.97853C5.84208 2.7832 6.15877 2.7832 6.3541 2.97853L11.0208 7.6452C11.2161 7.84053 11.2161 8.15722 11.0208 8.35255L6.3541 13.0192C6.2561 13.1179 6.1281 13.1665 6.0001 13.1665Z",
    fill: "#F4F5F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.4288feb4fb1c58edeec584796a7c8c65.svg";
export { ForwardRef as ReactComponent };